import React from 'react';

import * as S from './styles';

const Slide9: React.FC = () => {
  return (
    <S.Container>
      <S.Captions>
        <S.Staff>
          <S.StaffHeadline>Créditos</S.StaffHeadline>
          <S.StaffTextWrapper>
            <S.StaffText>
              <p>
                <span>Casting:</span>
                <br />
                Alice Wegmann
              </p>
              <p>
                <span>Produtora executiva:</span>
                <br />
                Isabela de Paula
              </p>
              <p>
                <span>Assistentes de produção: </span>
                <br />
                Carlos Henrique e Deise Cruz
              </p>
              <p>
                <span>Assistentes de foto:</span>
                <br />
                Henrique Lambiazi e Everton Sá
              </p>
              <p>
                <span>Vídeo: </span>
                <br />
                Caio Vieira
              </p>
              <p>
                <span>Produção de moda: </span>
                <br />
                John Fazzioli
              </p>
              <p>
                <span>Camareira:</span>
                <br />
                Jo Alcantara
              </p>
              <p>
                <span>Beleza:</span>
                <br />
                Angel Moraes
              </p>
              <p>
                <span>Assistente de beleza: </span>
                <br />
                Paola Salazar
              </p>
              <p>
                <span>Manicure:</span>
                <br />
                Sandra Goretti
              </p>
              <p>
                <span>Arte:</span>
                <br />
                Anderson Rodriguez
              </p>
              <p>
                <span>Assistente de arte:</span>
                <br />
                Leandro Rezende
              </p>
            </S.StaffText>
          </S.StaffTextWrapper>
        </S.Staff>
      </S.Captions>
    </S.Container>
  );
};

export { Slide9 };
